import BadgeSquare from 'components/badge/badgeSquare';
import { fillText } from 'components/invoiceImport/invoiceImportText';
import UseContext from 'hooks/useContext';
import BadgeTooltip from './BadgeTooltip';
import { lateTooltipText, statusTooltipText } from './invoiceStatusTooltipText';

// BadgeSquare type (its colour) and wording of each status the api gives.
const STATUS_BADGES = {
  error: { type: 3, key: 'error', fallback: 'Erreur' },
  draft: { type: 19, key: 'draft', fallback: 'Brouillon' },
  pending: { type: 20, key: 'pending', fallback: 'En attente' },
  partially_paid: {
    type: 16,
    key: 'partiallyPaid',
    fallback: 'Partiellement payé',
  },
  paid: { type: 14, key: 'paid', fallback: 'Payé' },
  cancelled: { type: 23, key: 'cancelled', fallback: 'Annulée' },
  not_imported: { type: 13, key: 'notImported', fallback: 'Non importé' },
};
const LATE_BADGE_TYPE = 17;

/**
 * Status of an invoice (JBWEB-1269) and, when it is late, how many days; each
 * badge says what it means on hover or focus (JBWEB-1272). Takes an invoice of
 * the list route, whose fields the detail (JBWEB-1274) shares.
 */
const InvoiceStatusBadge = ({ invoice }) => {
  const { language } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`invoiceList.${key}`, fallback);
  const tooltipText = (key, fallback) => text(`statusTooltip.${key}`, fallback);
  const badge = STATUS_BADGES[invoice.status];

  return (
    <div className="flex flex-wrap items-center gap-1">
      {badge && (
        <BadgeTooltip text={statusTooltipText(tooltipText, invoice)}>
          <BadgeSquare
            type={badge.type}
            customLabel={text(`status.${badge.key}`, badge.fallback)}
          />
        </BadgeTooltip>
      )}
      {invoice.lateDays > 0 && (
        <BadgeTooltip text={lateTooltipText(tooltipText, invoice)}>
          <BadgeSquare
            type={LATE_BADGE_TYPE}
            customLabel={fillText(text('late', 'En retard · {days} j'), {
              days: invoice.lateDays,
            })}
          />
        </BadgeTooltip>
      )}
    </div>
  );
};

export default InvoiceStatusBadge;
